import { Navigate, useLocation } from "react-router-dom";
import { ReactNode } from "react";
import usePermission from "../usePermission";
import { getRoutePermission, isRouteFeatureEnabled } from "../security/permissionMap";

type Props = {
  children: ReactNode;
};

const PrivateRoute = ({ children }: Props) => {

  const token = localStorage.getItem("token");
  const location = useLocation();
  const { can } = usePermission();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const required = getRoutePermission(location.pathname);
  if (required && (!isRouteFeatureEnabled(location.pathname) || !can(required.module, required.action))) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#F1F5F9",
        color: "#0F172A",
        padding: 24,
      }}>
        <div style={{
          width: "min(480px, 100%)",
          background: "#FFFFFF",
          border: "1px solid #CBD5E1",
          borderRadius: 8,
          boxShadow: "0 12px 30px rgba(15, 23, 42, 0.12)",
          padding: 24,
          textAlign: "center",
        }}>
          <div style={{ fontSize: 34, marginBottom: 10 }}>!</div>
          <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800 }}>Access denied</h2>
          <p style={{ margin: "8px 0 18px", color: "#64748B", fontSize: 14 }}>
            Aapke role me is page ka permission enabled nahi hai.
          </p>
          <button
            type="button"
            onClick={() => window.history.back()}
            style={{
              border: "none",
              background: "#1D4ED8",
              color: "#FFFFFF",
              borderRadius: 6,
              padding: "9px 16px",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Back
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default PrivateRoute;
